module.exports = __webpack_public_path__ + "static/media/sell-used-trucks-coopers.cdc23008.png";